import JwtTokenProvider from './lib';

let jwtTokenProvider;

export function newJwtTokenProvider(CALLBACKS) {
  if (!jwtTokenProvider) {
    jwtTokenProvider = new JwtTokenProvider(CALLBACKS);
  }

  return jwtTokenProvider;
}

export default function() {
  return jwtTokenProvider || {};
};



// WEBPACK FOOTER //
// ./src/features/login/jwt-token-provider/index.js